import { render, staticRenderFns } from "./DepartmentMemberTab.vue?vue&type=template&id=4be43698&scoped=true&"
import script from "./DepartmentMemberTab.vue?vue&type=script&lang=js&"
export * from "./DepartmentMemberTab.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentMemberTab.vue?vue&type=style&index=0&id=4be43698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be43698",
  null
  
)

export default component.exports